import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { clearResults, searchUsers } from "../redux/slices/authSlice";
import {
  addModerator,
  fetchChannelModerator,
  fetchUserById,
  removeModerator,
  resetCreateModerators,
  resetRemoveModerators, // Assuming you might have a reset for remove as well, or we just rely on fetch
} from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify"; // Ensure you have this installed/imported globally

const PaymentRap = styled.div`
  padding: 20px;
  .down-dash {
    background: #ffffff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 24px;
    min-width: 0;
  }
  select {
    background: #f8f8fa;
    height: 40px;
    border-radius: 100px;
    padding: 10px 20px;
    border: none;
  }
  .property-filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
  }
  .down-dash-header h4 {
    color: #00001c;
    font-size: 18px;
    font-weight: 600;
  }
  .down-dash-header button {
    background: #ed1c24;
    width: 136px;
    color: #ffffff;
    border-radius: 100px;
    height: 40px;
    border: none;
    font-weight: 600;
  }
  .down-dash-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .see-all {
    color: #cc9430;
    font-size: 16px;
    font-weight: 500;
  }
  th {
    font-size: 14px;
    font-weight: 500;
    color: #353546;
  }
  td {
    font-size: 13px;
    font-weight: 400;
    color: #353546;
  }
  .table-container {
    margin: 15px auto;
  }
  .new-table-scroll {
    width: 100% !important;
    overflow-x: auto;
  }

  .table-scroll {
    width: 100%;
    overflow-x: auto; /* horizontal scrolling */
    overflow-y: hidden; /* keep vertical clean; switch to auto if you want vertical too */
    -webkit-overflow-scrolling: touch;
  }

  /* Make the table at least 1000px wide; fill larger screens */
  .custom-table {
    border-collapse: collapse;
    text-align: left;
    border: 1px solid #f2f2f4;
    border-radius: 12px;
    /* 🔑 forces overflow on small screens, fits on large */
    width: max(100%, 1000px);
  }

  /* (Optional) If your layout parent is a flex item, also add: */
  .outlet,
  .table-scroll {
    min-width: 0; /* ensures scrolling works inside flex layouts */
  }

  /* your existing scrollbar styling still applies if you like */
  .table-scroll::-webkit-scrollbar {
    height: 6px;
  }
  .table-scroll::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  .table-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .table-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  table {
  }
  .custom-table thead {
    height: 40px;
  }
  .custom-table thead th {
    padding: 10px;
    background: #ffffff;
    border-bottom: 1px solid #f2f2f4;
    font-weight: 400;
    font-size: 12px;
    color: #667085;
  }
  .custom-table tbody {
    background: #ffffff;
  }
  .custom-table tbody tr {
    padding: 10px;
    border: 1px solid #f2f2f4;
  }
  .custom-table tbody td {
    padding: 10px;
    border: none;
    font-size: 15px;
    font-weight: 400;
    color: #667085;
  }
  .invoice-1 {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  /* Modal Styles */
  .dropdown-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .all-dropdown-div {
    background: white;
    padding: 20px;
    border-radius: 12px;
    width: 500px;
    max-width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  }

  .dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  form input,
  form select,
  form textarea {
    width: 100%;
    height: 40px;
    border-radius: 12px;
    padding-left: 15px;
    border: 1px solid #bac0d499;
  }
  form button {
    width: 100%;
    height: 40px;
    color: #ffffff;
    background: blue; /* Or your theme color */
    border: none;
    border-radius: 12px;
    cursor: pointer;
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    /* padding: 20px; */ /* Removed redundant padding */
  }
  form label {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .schedule-btn {
    width: 100%;
    height: 50px;
    border-radius: 100px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border: none;
    cursor: pointer;
  }
  .user-list {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #eee;
    margin-bottom: 15px;
    border-radius: 8px;
  }
  .user-item {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #f9f9f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .user-item:hover {
    background-color: #f0f0f0;
  }
  .selected-user-card {
    padding: 10px;
    background: #eef2ff;
    border: 1px solid #c7d2fe;
    border-radius: 8px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .remove-selection {
    cursor: pointer;
    color: red;
    font-size: 12px;
  }
  .remove-btn {
    background-color: #fff0f0;
    color: #d92d20;
    border: 1px solid #ffcdcd;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
  }

  @media (max-width: 500px) {
    .property-filter {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .search-input {
    width: 100%;
    height: 45px;
    border-radius: 12px;
    padding-left: 15px;
    border: 1px solid #bac0d499;
    background: #fcfcfd;
    outline: none;
    font-size: 14px;
    transition: all 0.2s ease;

    &:focus {
      border-color: #ed1c24;
      background: #ffffff;
      box-shadow: 0 0 0 4px rgba(237, 28, 36, 0.1);
    }

    &::placeholder {
      color: #a0a0a0;
    }
  }
`;

const Moderator = () => {
  const channelId = localStorage.getItem("pluglrUserChannelId");
  const dispatch = useDispatch();

  // Auth state for user search
  const { results, loading: searchLoading } = useSelector(
    (state) => state.auth
  );

  // User state for moderators
  const {
    moderatorloading,
    moderatorSuccess,
    channelModerator,
    loading: userLoading,
  } = useSelector((state) => state.userData);

  console.log(channelModerator);

  const [dropModerator, setDropModerator] = useState(false);
  const [query, setQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [moderatorUsers, setModeratorUsers] = useState({}); // Map userId -> user data
  const [formData, setFormData] = useState({
    userId: "",
    channelId: channelId,
  });

  useEffect(() => {
    if (channelId) {
      dispatch(fetchChannelModerator(channelId));
    }
  }, [dispatch, channelId]);

  // Fetch user details for each moderator
  useEffect(() => {
    if (channelModerator?.data && Array.isArray(channelModerator.data)) {
      channelModerator.data.forEach((mod) => {
        if (mod.userId && !moderatorUsers[mod.userId]) {
          dispatch(fetchUserById(mod.userId))
            .unwrap()
            .then((userData) => {
              setModeratorUsers((prev) => ({
                ...prev,
                [mod.userId]: userData.data || userData,
              }));
            })
            .catch((err) => {
              console.error(`Failed to fetch user ${mod.userId}:`, err);
            });
        }
      });
    }
  }, [channelModerator, dispatch]);

  // Handle Search Input Change
  const handleSearchChange = (e) => {
    const val = e.target.value;
    setQuery(val);

    if (val.trim() === "") {
      dispatch(clearResults());
      return;
    }

    if (typingTimeout) clearTimeout(typingTimeout);

    setTypingTimeout(
      setTimeout(() => {
        dispatch(searchUsers({ key: val, page: 1, pageSize: 10 }));
      }, 500)
    );
  };

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setFormData((prev) => ({
      ...prev,
      userId: user.id || user._id, // Handle different ID fields if any
    }));
    setQuery(""); // Clear query or keep it? Clearing is cleaner once selected.
    dispatch(clearResults());
  };

  const handleRemoveSelection = () => {
    setSelectedUser(null);
    setFormData((prev) => ({ ...prev, userId: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.userId) {
      toast.error("Please select a user");
      return;
    }

    // API expects { channelId, userId } as singular
    const payload = {
      channelId: channelId,
      userId: formData.userId,
    };

    dispatch(addModerator(payload)).then((res) => {
      if (!res.error) {
        dispatch(fetchChannelModerator(channelId)); // Refresh list
        handleCloseEventCreate();
      }
    });
  };

  const handleCloseEventCreate = () => {
    dispatch(resetCreateModerators());
    setDropModerator(false);
    setSelectedUser(null);
    setQuery("");
    setFormData({
      userId: "",
      channelId: channelId,
    });
    dispatch(clearResults());
  };

  const handleRemoveModerator = (userId) => {
    if (window.confirm("Are you sure you want to remove this moderator?")) {
      dispatch(removeModerator({ channelId, userId })).then((res) => {
        if (!res.error) {
          toast.success("Moderator removed successfully");
          dispatch(fetchChannelModerator(channelId));
        } else {
          toast.error(res.payload || "Failed to remove moderator");
        }
      });
    }
  };

  // Effect to close modal on success
  useEffect(() => {
    if (moderatorSuccess) {
      // We can keep the success modal or just close it and show toast
      // The existing code has a success modal state, let's respect that structure or adapt.
      // The existing code showed a success message *instead* of the form.
      // I'll stick to that flow.
    }
  }, [moderatorSuccess]);

  return (
    <PaymentRap>
      <div className="down-dash">
        <div className="down-dash-header">
          <h4>Moderator</h4>
          {/* Main Add Button */}
          <button onClick={() => setDropModerator(true)}>Add moderator</button>
        </div>

        <div className="table-scroll">
          <table className="custom-table">
            <thead>
              <tr>
                <th>User</th>

                <th>Email</th>
                <th>Date Added</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {channelModerator &&
              channelModerator.data &&
              channelModerator.data.length > 0 ? (
                channelModerator.data.map((mod, index) => {
                  // Get user details from our fetched mapping
                  const user = moderatorUsers[mod.userId];

                  // Show loading state if user data not yet fetched
                  if (!user) {
                    return (
                      <tr key={mod.id || mod._id || index}>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                          <ClipLoader size={15} />
                        </td>
                      </tr>
                    );
                  }

                  return (
                    <tr key={mod.id || mod._id || index}>
                      <td>
                        <div className="invoice-1">
                          <img
                            src={
                              user.image ||
                              user.profileImage ||
                              "/images/image_1.png"
                            }
                            alt=""
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                          {user.fname} {user.lname}
                        </div>
                      </td>

                      <td>{user.email}</td>
                      <td>{new Date(mod.assignedAt).toLocaleDateString()}</td>
                      <td>
                        <button
                          className="remove-btn"
                          onClick={() => handleRemoveModerator(mod.userId)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    {userLoading ? (
                      <ClipLoader size={20} />
                    ) : (
                      "No moderators found."
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* CREATE MODERATOR MODAL */}
      {dropModerator && (
        <div className="dropdown-container">
          <div className="all-dropdown-div">
            {moderatorSuccess ? (
              <div className="dropdown-div" style={{ textAlign: "center" }}>
                <p
                  style={{
                    margin: "auto",
                    fontSize: "20px",
                    maxWidth: "300px",
                    fontWeight: "600",
                    paddingBottom: "30px",
                  }}
                >
                  {moderatorSuccess?.message || "Moderator added successfully!"}
                </p>
                <button
                  onClick={handleCloseEventCreate}
                  className="schedule-btn"
                >
                  CLOSE
                </button>
              </div>
            ) : (
              <>
                <div className="dropdown-header">
                  <h4>Create Moderator</h4>
                  <Icon
                    width="30px"
                    height="30px"
                    icon="humbleicons:times"
                    color="#060B13"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setDropModerator(false);
                      dispatch(clearResults());
                      setSelectedUser(null);
                    }}
                  />
                </div>

                {/* Search Section */}
                {!selectedUser && (
                  <div style={{ marginBottom: "20px" }}>
                    <label
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        marginBottom: "8px",
                      }}
                    >
                      Search User
                    </label>
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search by name..."
                      value={query}
                      onChange={handleSearchChange}
                    />
                    {searchLoading && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#888",
                          marginTop: "5px",
                        }}
                      >
                        Searching...
                      </div>
                    )}
                  </div>
                )}

                {/* User Selection List */}
                {!selectedUser && results?.data?.length > 0 && (
                  <div className="user-list">
                    {results.data.map((user) => (
                      <div
                        key={user.id || user._id}
                        className="user-item"
                        onClick={() => handleSelectUser(user)}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <img
                            src={
                              user.image ||
                              user.profileImage ||
                              "/images/image_1.png"
                            }
                            alt=""
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          />
                          <div>
                            <div
                              style={{ fontSize: "14px", fontWeight: "600" }}
                            >
                              {user.fname} {user.lname}
                            </div>
                            <div style={{ fontSize: "12px", color: "#666" }}>
                              {user.email}
                            </div>
                          </div>
                        </div>
                        <Icon icon="akar-icons:plus" />
                      </div>
                    ))}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  {/* Selected User Display */}
                  {selectedUser && (
                    <div className="selected-user-card">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <img
                          src={
                            selectedUser.image ||
                            selectedUser.profileImage ||
                            "/images/image_1.png"
                          }
                          alt=""
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                          }}
                        />
                        <div>
                          <div style={{ fontWeight: "600" }}>
                            {selectedUser.fname} {selectedUser.lname}
                          </div>
                          <div style={{ fontSize: "12px", color: "#555" }}>
                            {selectedUser.email}
                          </div>
                        </div>
                      </div>
                      <div
                        className="remove-selection"
                        onClick={handleRemoveSelection}
                      >
                        Change
                      </div>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={moderatorloading}
                    style={{ background: "#ed1c24" }}
                  >
                    {moderatorloading ? (
                      <ClipLoader color="white" size={24} />
                    ) : (
                      "Add Moderator"
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </PaymentRap>
  );
};

export default Moderator;
